import { useState, useEffect } from 'react';
import Header from '../directives/header';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/poadcast.css';
import LatestVideos from './latestVideos';

const Podcast = () => {
  const [positionClass, setPositionClass] = useState('relative');

  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 767 ? 'absolute' : 'relative');
    };

    updatePosition(); // Set initial state
    window.addEventListener('resize', updatePosition);

    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <>
      <Header />
      <main>
        <div
          className="subheader"
          style={{
            background:
              'linear-gradient(45deg, #01053df0 54%, #32cfda  104%, #000000e6  50%), url(assets/images/poadcast/pattern.png) repeat',
              backgroundRepeat:'repeat!important',
              backgroundSize:'cover!important',
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <h2 className="fw-bold text-white">Podcast</h2>
                <p>
                  Welcome to the Unitronix Podcast, where we bring you the
                  latest updates, announcements, and insights from the world of
                  blockchain, tokenized finance, and decentralized investments.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <section className="poadcast position-relative">
          <Container className="">
            <Row className="">
              <Col lg={12} className=" mb-5">
                <LatestVideos />
              </Col>
            </Row>
          </Container>
        </section>
      </main>

      <Footer />
    </>
  );
};
export default Podcast;
